(function () {
    angular.module('agweb').controller('PropertyDetailsController', [ '$interval', '$timeout',
        function PropertyDetailsController($interval, $timeout) {
            var ctrl = this;

            var detailPopup = null;

            var tenantInfo = null; 
            var mapPopup = null;

            ctrl.ux = {
                popupUrl: null,
                mapOpen: false,
            };
            ctrl.setSlideIndex = 0;
            ctrl.largeSlideIndex = 0;

            //-
            ctrl.showPopup = function (url) {
                ctrl.ux.popupUrl = url;

                detailPopup = global.showDomPopup({
                    callerWindow: window,
                    domID: 'detail-popup',
                });
            };

            ctrl.closePopup = function () {
                detailPopup.close();
            };

            ctrl.showMap = function () {
                ctrl.ux.mapOpen = true;
                mapPopup = global.showDomPopup({
                    callerWindow: window,
                    domID: 'map-popup'
                })
            };

            ctrl.closeMap = function () {
                ctrl.ux.mapOpen = false;
                mapPopup.close();
            };

            ctrl.showTenantInfo = function () {
                tenantInfo = global.showDomPopup({
                    callerWindow: window,
                    domID: 'tenant-info-popup'
                })
            };

            ctrl.closeTenantInfo = function () {
                tenantInfo.close();
            };

            ctrl.slideNavigate = function ($event) {
                // Set the slide index when large image is navigated,
                // so the small gallery can sync with it.
                ctrl.largeSlideIndex = $event.index;
            };

            // Make the large slide set to the index of the image clicked in the gallery
            ctrl.showImage = function ($event) {
                if ($event.item) {
                    ctrl.setSlideIndex = $event.index;
                }
            };

            ctrl.navigate = function (code) {
                window.location.href = urls.PropertyDetail + code;
            };

            ctrl.bookViewing = function () {
                window.location.href = `${urls.BookAViewing}?Address=${encodeURI(ctrl.Prop.FullAddress)}&Code=${ctrl.Prop.PropertyCode}${ctrl.Prop.Lettings ? '&Lettings=true' : ''}${ctrl.Prop.Prestige? '&Prestige=true' : ''}`;
            };
            
            ctrl.init = function () {
                // propertydetail is injected in a script tag before the declaration of the controller in the propertydetail.cshtml file
                var rd = window.propertydetail;

                if (!!rd) {
                    ctrl.Prop = rd.Prop;
                    ctrl.Territory = rd.Territory;
                    ctrl.Images = rd.Images;
                    ctrl.BrochureUrl = rd.BrochureUrl;
                    ctrl.EPCUrl = rd.EPCUrl;
                    ctrl.FloorPlanUrl = rd.FloorPlanUrl;
                    //ctrl.Similar = rd.Similar;
                }

            };
            //-i

            ctrl.init();
        }
    ]);
})();

app.filter('customSplitString', function () {
    return function (input) {
        var arr = input.split(',');
        return arr;
    };
});